import React, { Component } from "react";
import { Row, Col, Card, Button, Container, Form, Table } from "react-bootstrap";
import moment from 'moment';
import * as Cookies from "es-cookie";
import * as XLSX from "xlsx-js-style";
import jsPDF from "jspdf";
import AttendanceReportModal from './attendanceModal';
import "./_tableReportData.scss";
import CardLessDataTable from '../datatables/CardLessDataTableWithSearch';

class ReportTableData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            attendanceReportModal: false,
            startDateInput: moment.unix(this.props.stateData.startDateCalender).format("YYYY-MM-DD"),
            endDateInput: moment.unix(this.props.stateData.endDateCalender).format("YYYY-MM-DD"),
            dateArrayfinal: [],
            loader: 0,
            mainTableStartDate: moment.unix(this.props.stateData.startDateCalender).format("DD-MM-YYYY"),
            mainTableEndDate: moment.unix(this.props.stateData.endDateCalender).format("DD-MM-YYYY"),
            roomWiseData: [],
        };
    }

    componentDidMount() {
        var dateArray = [];
        var currentDate = moment(this.state.startDateInput);
        var stopDate = moment(this.state.endDateInput);
        while (currentDate <= stopDate) {
            dateArray.push({ date: moment(currentDate).format('DD-MM-YYYY'), unixDate: moment(currentDate, 'MM-DD-YYYY').unix() })
            currentDate = moment(currentDate).add(1, 'days');
        }
        this.setState({ dateArrayfinal: dateArray })
    }

    articlecolumns = [
        {
            dataField: "date",
            text: "FromDate    to    ToDate",
            // sort: true,
        },
        {
            dataField: "building_name",
            text: "Building",
            sort: true,
        },
        {
            dataField: "floor_name",
            text: "Floor",
            sort: true,
        },
        {
            dataField: "room_name",
            text: "Room",
            sort: true,
        },
        {
            dataField: "no_of_students",
            text: "No of Students",
            sort: true,
        },
        {
            dataField: "Details",
            text: "Details",
            formatter: this.performanceFunc.bind(this),
        },
    ];

    performanceFunc(val, row) {
        console.log("rowwwwwwwwwww", row)
        return (<>
            <div className="actions-buttons d-flex justify-content-center align-items-top" onClick={() => this.setState({ attendanceReportModal: true, roomWiseData: row.attendanceData })}>
                <Button variant="link" name="edit" className="text-theme">
                    <i className="fas fa-eye" />
                </Button>
            </div>
        </>)
    }

    // Build the filtered, room-wise table rows from the selected filters.
    buildTableData = () => {
        const propsData = this.props;
        const overAllDetails = this.props.stateData.getBuildingFloorAndRoomDetails;
        const FilterBuildings = overAllDetails.filter((item) => item.hostel_building_id == propsData.stateData.buildingSearch);

        let tableData = [];
        if (!FilterBuildings.length) return tableData;

        propsData.stateData.roomSelectedvalue.map((item) => {
            FilterBuildings[0].floors_details.map((item2) => {
                item2.rooms_details.map((item3) => {
                    if (item.value == item3.room_id) {
                        let presentCount = item3.capacity_details.filter((item4) => item4.attendance_status == 1 && item4.attended_date != null).length
                        let absentCount = item3.capacity_details.filter((item4) => item4.attendance_status == 0 && item4.attended_date != null).length

                        const uniqueStudents = item3.capacity_details.filter(
                            (currentObj, currentIndex, self) =>
                                self.findIndex((obj) => obj.edu_student_id === currentObj.edu_student_id) === currentIndex
                        ).filter((obj) =>
                            // Count only bed-allocated students that resolve to a real name.
                            (this.props.allStudents || []).some((s) => s.student_id == obj.edu_student_id)
                            || (this.props.getNewEducationalStudents || []).some((s) => s.student_id == obj.edu_student_id)
                        );

                        tableData.push({ date: `${this.state.mainTableStartDate + " to " + this.state.mainTableEndDate}`, building_name: propsData.stateData.buildingName, floor_name: item2.floor_name, room_name: item3.room_name, no_of_students: uniqueStudents.length, presentCount: presentCount, absentCount: absentCount, attendanceData: item3.capacity_details })
                    }
                })
            })
        });
        return tableData;
    }

    // Common report metadata + totals used by both Excel and PDF exports.
    getReportMeta = (tableData) => {
        const totalPresent = tableData.reduce((s, r) => s + (r.presentCount || 0), 0);
        const totalAbsent = tableData.reduce((s, r) => s + (r.absentCount || 0), 0);
        const totalMarked = totalPresent + totalAbsent;
        return {
            collegeName: Cookies.get("institutename") || Cookies.get("institutionname") || "Hostel",
            branchName: this.props.stateData.branchSearchval?.label || Cookies.get("branch_name") || "-",
            buildingName: this.props.stateData.buildingName || "-",
            dateRange: `${this.state.mainTableStartDate} to ${this.state.mainTableEndDate}`,
            generatedOn: moment().format("DD-MM-YYYY hh:mm A"),
            totalRooms: tableData.length,
            totalStudents: tableData.reduce((s, r) => s + (r.no_of_students || 0), 0),
            totalPresent,
            totalAbsent,
            attendancePct: totalMarked ? `${Math.round((totalPresent / totalMarked) * 100)}%` : "-",
        };
    }

    exportFileName = (ext) => {
        const building = (this.props.stateData.buildingName || "hostel").replace(/[^\w-]+/g, "_");
        return `hostel_attendance_${building}_${this.state.mainTableStartDate}_to_${this.state.mainTableEndDate}.${ext}`;
    }

    exportExcel = () => {
        const tableData = this.buildTableData();
        if (!tableData.length) return;
        const m = this.getReportMeta(tableData);

        const sheetData = [
            [m.collegeName],
            ["Hostel Attendance Report"],
            ["Date Range", m.dateRange, null, null, null, null, "Generated On", m.generatedOn],
            [],
            ["S.No", "Branch", "Building", "Floor", "Room", "No of Students", "Present", "Absent"],
            ...tableData.map((row, idx) => [
                idx + 1,
                m.branchName,
                row.building_name,
                row.floor_name,
                row.room_name,
                row.no_of_students,
                row.presentCount,
                row.absentCount,
            ]),
            ["Total", "", "", "", "", m.totalStudents, m.totalPresent, m.totalAbsent],
        ];

        const headerRowIndex = 4; // college, title, date, blank, header
        const totalRowIndex = 5 + tableData.length; // ...then data, then total
        const worksheet = XLSX.utils.aoa_to_sheet(sheetData);
        worksheet["!cols"] = [{ wch: 8 }, { wch: 24 }, { wch: 24 }, { wch: 16 }, { wch: 16 }, { wch: 16 }, { wch: 12 }, { wch: 12 }];
        worksheet["!merges"] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: 7 } },
            { s: { r: 1, c: 0 }, e: { r: 1, c: 7 } },
            { s: { r: totalRowIndex, c: 0 }, e: { r: totalRowIndex, c: 4 } },
        ];

        // ── Styling (xlsx-js-style) so the header & total rows stand out ──
        const titleStyle = { font: { bold: true, sz: 14, color: { rgb: "7C3AED" } }, alignment: { horizontal: "center" } };
        const subTitleStyle = { font: { bold: true, sz: 11, color: { rgb: "475569" } }, alignment: { horizontal: "center" } };
        const headerStyle = {
            font: { bold: true, color: { rgb: "FFFFFF" } },
            fill: { fgColor: { rgb: "7C3AED" } },
            alignment: { horizontal: "center", vertical: "center" },
        };
        const totalStyle = {
            font: { bold: true, sz: 12, color: { rgb: "5B21B6" } },
            fill: { fgColor: { rgb: "EDE9FE" } },
            alignment: { horizontal: "center" },
        };
        const totalLabelStyle = { ...totalStyle, alignment: { horizontal: "left" } };

        const setStyle = (r, c, style) => {
            const ref = XLSX.utils.encode_cell({ r, c });
            if (worksheet[ref]) worksheet[ref].s = style;
        };

        setStyle(0, 0, titleStyle);
        setStyle(1, 0, subTitleStyle);
        for (let c = 0; c <= 7; c++) setStyle(headerRowIndex, c, headerStyle);
        for (let c = 0; c <= 7; c++) setStyle(totalRowIndex, c, c === 0 ? totalLabelStyle : totalStyle);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Hostel Attendance");
        XLSX.writeFile(workbook, this.exportFileName("xlsx"));
    }

    exportPDF = () => {
        const tableData = this.buildTableData();
        if (!tableData.length) return;
        const m = this.getReportMeta(tableData);

        const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
        const pageWidth = doc.internal.pageSize.width;
        const pageHeight = doc.internal.pageSize.height;
        const marginX = 10;
        const purple = [124, 58, 237];

        // ── Header banner ──
        doc.setFillColor(...purple);
        doc.rect(0, 0, pageWidth, 26, "F");
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(15);
        doc.text(m.collegeName, pageWidth / 2, 12, { align: "center" });
        doc.setFontSize(11);
        doc.text("Hostel Attendance Report", pageWidth / 2, 20, { align: "center" });

        // ── Meta block ──
        doc.setTextColor(33, 37, 41);
        doc.setFontSize(9);
        doc.text(`Branch: ${m.branchName}`, marginX, 34);
        doc.text(`Building: ${m.buildingName}`, marginX, 39);
        doc.text(`Date: ${m.dateRange}`, pageWidth - marginX, 34, { align: "right" });
        doc.text(`Generated: ${m.generatedOn}`, pageWidth - marginX, 39, { align: "right" });

        // ── Summary line ──
        doc.setFillColor(245, 243, 255);
        doc.rect(marginX, 43, pageWidth - marginX * 2, 9, "F");
        doc.setTextColor(91, 33, 182);
        doc.setFontSize(9);
        doc.text(
            `Rooms: ${m.totalRooms}    Students: ${m.totalStudents}    Present: ${m.totalPresent}    Absent: ${m.totalAbsent}    Attendance: ${m.attendancePct}`,
            pageWidth / 2, 49, { align: "center" }
        );

        const headers = ["S.No", "Building", "Floor", "Room", "Students", "Present", "Absent"];
        const colWidths = [14, 45, 35, 35, 22, 19, 20]; // sums to 190 (usable width)
        const colX = [];
        let x = marginX;
        colWidths.forEach((w) => { colX.push(x); x += w; });

        const rowHeight = 8;
        let y = 58;

        const drawHeader = () => {
            doc.setFillColor(...purple);
            doc.setTextColor(255, 255, 255);
            doc.setFontSize(9);
            doc.rect(marginX, y, pageWidth - marginX * 2, rowHeight, "F");
            headers.forEach((h, i) => doc.text(String(h), colX[i] + 2, y + 5.5));
            y += rowHeight;
            doc.setTextColor(33, 37, 41);
        };

        drawHeader();

        tableData.forEach((row, idx) => {
            if (y + rowHeight > pageHeight - 12) {
                doc.addPage();
                y = 16;
                drawHeader();
            }
            if (idx % 2 === 0) {
                doc.setFillColor(245, 243, 255);
                doc.rect(marginX, y, pageWidth - marginX * 2, rowHeight, "F");
            }
            const cells = [
                idx + 1,
                row.building_name,
                row.floor_name,
                row.room_name,
                row.no_of_students,
                row.presentCount,
                row.absentCount,
            ];
            doc.setFontSize(8);
            cells.forEach((c, i) => {
                const text = doc.splitTextToSize(String(c ?? "-"), colWidths[i] - 3)[0];
                doc.text(text, colX[i] + 2, y + 5.5);
            });
            y += rowHeight;
        });

        // ── Totals row ──
        if (y + rowHeight > pageHeight - 12) { doc.addPage(); y = 16; }
        doc.setFillColor(237, 233, 254);
        doc.rect(marginX, y, pageWidth - marginX * 2, rowHeight, "F");
        doc.setFontSize(8);
        doc.setTextColor(0, 0, 0);
        doc.text("Total", colX[1] + 2, y + 5.5);
        doc.text(String(m.totalStudents), colX[4] + 2, y + 5.5);
        doc.text(String(m.totalPresent), colX[5] + 2, y + 5.5);
        doc.text(String(m.totalAbsent), colX[6] + 2, y + 5.5);

        // ── Page numbers ──
        const pageCount = doc.internal.getNumberOfPages();
        for (let p = 1; p <= pageCount; p++) {
            doc.setPage(p);
            doc.setFontSize(8);
            doc.setTextColor(120, 120, 120);
            doc.text(`Page ${p} of ${pageCount}`, pageWidth - marginX, pageHeight - 6, { align: "right" });
        }

        doc.save(this.exportFileName("pdf"));
    }

    render() {

        const tableData = this.buildTableData();

        return (
            <section>
                <div className="">
                    <Container>
                        {
                            tableData.length > 0 ? (
                                <div className="hostel-report-table">
                                    <CardLessDataTable
                                        parentData={tableData}
                                        particlecolumns={this.articlecolumns}
                                        name="hostel_attendance"
                                        SearchBar={true}
                                        onExportExcel={this.exportExcel}
                                        onExportPDF={this.exportPDF}
                                    />
                                </div>
                            )
                                :
                                (
                                    <Row>
                                        <div style={{ backgroundColor: "red" }}>
                                            <h4 className='mt-3 text-center'><span className="text-danger"> * </span>  No data available</h4>
                                        </div>
                                    </Row>
                                )
                        }
                    </Container>
                    <AttendanceReportModal
                        show={this.state.attendanceReportModal}
                        onHide={() => this.setState({ attendanceReportModal: false, loader: 0 })}
                        stateData={this.state}
                        globals={this.props.globals}
                        getNewEducationalStudents={this.props.getNewEducationalStudents}
                        allStudents={this.props.allStudents}
                    />
                </div>
            </section>
        );
    }
}
export default ReportTableData;